import { hasLength } from '@mantine/form';
import { MAX_EVENT_DESCRIPTION_LENGTH } from '@/constants';

export const normalizeEventDescription = (description: string | null | undefined): string => description ?? '';

export const getEventDescriptionValidator = (descriptionMaxLength: string) => (value: string | null | undefined) =>
  hasLength({ max: MAX_EVENT_DESCRIPTION_LENGTH }, descriptionMaxLength)(normalizeEventDescription(value));
